module.exports = __webpack_public_path__ + "img/yingyong_icon01.f2a62bcb.png";